import {HTTP, ERROR} from '@/http-common';
import FileSaver from "file-saver";
import Vue from 'vue';

const state = {
  step: 1,
  forms: [],
  fields: {},
  filename: '',
  originalFilename: '',
  formId: 0,
  importStatus: {},
  importLog: [],
  summary: {
    count: 0,
    exceptionsCount: 0,
    success: false,
    columns: [],
    exceptions: [],
    map: [],
    keyField: {},
    formId: null
  },
  importId: null,
  history: [],
  historySingle: {},
};

const mutations = {
  SET_IMPORTS_STEP(state, data) {
    state.step = data
  },
  SET_IMPORTS_FORMS(state, data) {
    state.forms = data.forms
  },
  SET_IMPORT_FORM_ID(state, data) {
    state.importId = null;
    state.formId = data
  },
  RESET_IMPORTS_FIELDS(state) {
    state.fields = [];
  },
  SET_IMPORTS_FIELDS(state, data) {
    state.fields = data.fields
    state.filename = data.filename
    state.formId = data.formId
  },
  SET_IMPORTS_ORIGINAL_FILENAME(state, data) {
    state.originalFilename = data
  },
  SET_IMPORT_STATUS(state, data) {
    state.importStatus = data
  },
  SET_IMPORT_HISTORY(state, data) {
    state.history = data
  },
  SET_IMPORT_HISTORY_SINGLE(state, data) {
    state.historySingle = data
  },
  RESET_IMPORT_LOGS(state) {
    state.importLog = [];
  },
  ADD_IMPORT_LOG(state, data) {
    state.importLog.push(data);
  },
  SET_IMPORT_SUMMARY(state, data) {
    state.summary = data;
  },
  SET_IMPORT_ID(state, data) {
    state.importId = data;
  }
}

const getters = {
  getImportsStep: state => state.step,
  getImportsForms: state => state.forms,
  getImportFormId: state => state.formId,
  getImportFilename: state => state.filename,
  getImportOriginalFilename: state => state.originalFilename,
  getImportKeyField: state => state.keyField,
  getImportsFields: state => state.fields,
  getImportsSummary: state => state.summary,
  getImportsFilename: state => state.filename,
  getImportsForm: state => state.formId,
  getImportStatus: state => state.importStatus,
  getImportsHistory: state => state.history,
  getImportsHistorySingle: state => state.historySingle,
  getImportId: state => state.importId
}

const actions = {
  SET_IMPORTS_STEP_ACTION({commit}, payload) {
    commit('SET_IMPORTS_STEP', payload)
  },

  GET_IMPORTS_FORMS_ACTION: ({commit}) => {
    HTTP.get(`imports/forms`)
      .then(response => {
        ERROR(response)
        if (response.data.status === 'success') {
          commit('SET_IMPORTS_FORMS', response.data.data)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },

  GET_IMPORTS_TEMPLATE_ACTION: ({commit}, payload) => {
    HTTP.get(`imports/template?id=${payload}`)
      .then(response => {
        ERROR(response);

        let filename = '';

        if(payload === 0) {
          filename = 'Template_CommunicationNotes.csv';
        } else {
          filename = 'Template_'+payload+'.csv';
        }

        let blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, filename);
      }).catch(err => {
      console.log(err);
    })
  },

  IMPORTS_UPLOAD_ACTION: ({commit, dispatch}, payload) => {
    payload.fd.append('data', JSON.stringify({form_id: state.formId, original_filename: payload.name}));
    return HTTP.post(`imports/upload`, payload.fd)
      .then(response => {
        ERROR(response);
        if (response.data.status === 'success') {
          commit('SET_IMPORTS_ORIGINAL_FILENAME', payload.name);
          commit('SET_IMPORTS_FIELDS', response.data.data);
        }
        return response;
      })
      .catch(err => {
        console.log(err)
      })
  },

  IMPORTS_VALIDATE_ACTION: ({commit, getters}, payload) => {
    commit('RESET_IMPORT_LOGS');

    let req = {
      form_id: getters.getImportFormId,
      filename: getters.getImportFilename,
      original_filename: getters.getImportOriginalFilename,
      ignore_required: payload.ignore_required,
      map: payload.map,
      key_field: payload.key_field,
    };

    if (payload.ref) {
      payload.ref.loading = true;
    }

    return HTTP.post(`imports/pre-validate`, req).then(response => {
      ERROR(response);
      if (payload.ref) {
        payload.ref.loading = false;
      }
      if (response.data.status === 'success') {
        commit('SET_IMPORT_SUMMARY', response.data.data.summary);
        payload.context.nextTab();
      }
      if (response.data.status === 'error') {
        Vue.prototype.$notify({
          type: 'error',
          text: response.data.message
        });
      }
    }).catch(err => {
      if (payload.ref) {
        payload.ref.loading = false;
      }
      console.log(err)
    })
  },

  IMPORT_CREATE_ACTION: ({commit, getters}, payload) => {

    if (payload.ref) {
      payload.ref.loading = true;
    }

    return HTTP.post(`imports/create`, {
      filename: getters.getImportFilename,
      original_filename: getters.getImportOriginalFilename,
      form_id: getters.getImportFormId,
      map: getters.getImportsSummary.map,
      total_rows: getters.getImportsSummary.count,
      exceptions_rows: getters.getImportsSummary.exceptionsRows,
      key_field: getters.getImportsSummary.keyField,
    }).then(response => {
      ERROR(response);
      commit('SET_IMPORT_STATUS', response.data.data);
      commit('ADD_IMPORT_LOG', response.data.data);
      commit('SET_IMPORT_ID', response.data.data.id);
      Vue.prototype.$notify({
        type: 'info',
        text: response.data.data.message
      });
      return response;
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      if (payload.ref) {
        payload.ref.loading = false;
      }
    });
  },
  IMPORT_RUN_ACTION: ({commit}, payload) => {
    return HTTP.post('imports/run', {
      id: payload.id
    }).then(response => {
      ERROR(response);
      Vue.prototype.$notify({
        type: 'info',
        text: response.data.data.message
      });
    }).catch (err => {
      console.log(err);
    });
  },

  IMPORTS_HISTORY_ACTION: ({commit}) => {
    return HTTP.get(`imports/history`)
      .then(response => {
        ERROR(response);
        if (response.data.status === 'success') {
          commit('SET_IMPORT_HISTORY', response.data.data);
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  IMPORTS_HISTORY_SINGLE_ACTION: ({commit}, payload) => {
    return HTTP.post(`imports/show`, payload)
      .then(response => {
        ERROR(response);
        if (response.data.status === 'success') {
          commit('SET_IMPORT_HISTORY_SINGLE', response.data.data);
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  IMPORTS_EXPORT_EXCEPTIONS: ({commit}, payload) => {
    let queryString = Object.keys(payload).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(payload[key])
    }).join('&');

    // todo: change this endpoint
    HTTP.get(`imports/import?` + queryString)
      .then(response => {
        let blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `ImportExceptions.csv`);
      })
      .catch(err => {
        console.log(err)
      })
  },
  IMPORTS_HISTORY_EXPORT_EXCEPTIONS: ({commit}, payload) => {
    return HTTP.get(`imports/export-exceptions`, {'params': {'id': payload}})
      .then(response => {
        let blob = new Blob([response.data], {type: response.headers['content-type']});
        FileSaver.saveAs(blob, `ImportExceptions.csv`);
      })
      .catch(err => {
        console.log(err)
      })
  },
  IMPORTS_RESET_HISTORY_SINGLE: ({commit}) => {
    commit('SET_IMPORT_HISTORY_SINGLE', {
        data: {
          original_file: '',
          failed_rows_count: 0,
          success_rows_count: 0
        },
        failedRows: []
      }
    )
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/imports.js